/* eslint-disable */ 
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import lottie from "lottie-web";
import {} from "isotope-masonry-horizontal";
import Isotope from "isotope-layout";
import Flickity from "flickity";
import gsap from "gsap";
import barba from "@barba/core";
import Draggable from "gsap/Draggable";
import InertiaPlugin from "gsap/InertiaPlugin";
import Button from "./utils/button";

gsap.registerPlugin(Draggable, InertiaPlugin);

const HTML = document.querySelector("html");

window.timeoutIds = [];

// store the original method
const originalTimeoutFn = window.setTimeout;

//over-writing the original method
window.setTimeout = function(fn, delay) { 
  const id = originalTimeoutFn(fn, delay);
  timeoutIds.push(id);
  
  //return the id so that it can be originally cleared
  return id;
}

window.clearAllTimeout = function(){
  //clear all timeouts
  while(timeoutIds.length){
    clearTimeout(timeoutIds.pop());
  }
}

function sleep(delay) {
  return new Promise((resolve) => setTimeout(resolve, delay))
}

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // MENU
    const toggleMenu = document.querySelectorAll(".toggle-menu");
    if (toggleMenu) {
      toggleMenu.forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });
    }

    this.container = HTML;
    this.gridHours();
    this.sliderScreen();
    this.asynchroneLoaded();
    this.init();
  }

  init() {
    this.button();
    this.sound();
    this.drag();
    this.marquee();
    this.bodymovin();
    this.slider();
    this.grid();
    this.poll();
    this.inViewport();
  }

  unmount() {}

  asynchroneLoaded() {
    const _ = this;
    const header = document.querySelector(".main-header");

    if (!document.querySelector("[data-barba]")) return;

    barba.hooks.after(() => {
      if (typeof gtag !== "undefined") {
        gtag("event", "page_view", {
          page_title: document.title,
          page_location: location.href,
          page_path: location.pathname,
        });
      }
    });

    let oldScrollY = 0;
    barba.init({
      timeout: 15000,
      transitions: [
        {
          name: "default-transition",
          leave(data) {
            HTML.classList.add("no-event");
            HTML.classList.remove("open-menu", "open-filter", "open-concert");

            if (data.current.namespace == "category") {
              oldScrollY = window.scrollY;
              return leaveCategory(data);
            }
            if (data.current.namespace == "single") {
              return leaveSingle(data);
            }

            return gsap.to(data.current.container, {
              opacity: 0,
              duration: 0.3,
              onComplete: () => {
                window.scrollTo(0, 0);
                _.unmount();
              },
            });
          },
          enter(data) {
            _.lazyload.update();
            HTML.classList.remove("no-event");

            _.container = data.next.container;

            document.body.className = data.next.container.dataset.class;

            const form = data.next.container.querySelector(".wpcf7 form");
            if (form) wpcf7.init(form);

            /** HIDE MENU IF NEXT NAMESPACE IS SINGLE */
            if (data.next.namespace == "single") {
              gsap.to(header, {
                duration: 0.3,
                autoAlpha: 0,
                y: "-2rem",
                ease: "circ.inOut",
              });
            } else {
              gsap.to(header, {
                duration: 0.3,
                autoAlpha: 1,
                y: "0rem",
                ease: "circ.inOut",
              });
            }

            return gsap.from(data.next.container, {
              opacity: 0,
              duration: 0.3,
              onComplete: () => {
                if (
                  data.next.namespace == "category" &&
                  data.current.namespace == "single" &&
                  oldScrollY > 0
                ) {
                  gsap.to(HTML, {
                    ease: "expo.out",
                    duration: 0.2,
                    scrollTop: oldScrollY,
                  });
                  oldScrollY = 0;
                }
                _.init(data.next.container);
                gsap.set(data.next.container, { clearProps: "all" });
              },
            });
          },
        },
      ],
    });

    function leaveCategory(data) {
      const iso = Isotope.data(".list-articles");
      const tl = gsap.timeline({
        paused: true,
        onComplete: () => {
          window.scrollTo(0, 0);
          _.unmount();
        },
      });

      tl.to(
        data.current.container.querySelectorAll("[data-bodymovin]"),
        {
          autoAlpha: 0,
          duration: 0.3,
        },
        "start"
      ).to(
        data.current.container.querySelector(".progress"),
        {
          autoAlpha: 0,
          y: "-1rem",
          duration: 0.3,
        },
        "start"
      );

      // HIDE HEADER LISTING
      const catHeader =
        data.current.container.querySelector(".category-header");
      if (catHeader) {
        tl.to(
          catHeader.querySelector("figure"),
          {
            duration: 0.5,
            autoAlpha: 0,
            y: "-20%",
            ease: "circ.in",
          },
          "start"
        )
          .to(
            catHeader.querySelector(".main-logo"),
            {
              duration: 0.3,
              autoAlpha: 0,
            },
            "start"
          )
          .to(
            catHeader.querySelectorAll(".nav li"),
            {
              duration: 0.3,
              autoAlpha: 0,
              x: "-1.5rem",
              stagger: 0.1,
            },
            "start"
          );
      }

      // HIDE FOOTER LISTING
      const footer = data.current.container.querySelector(".main-footer");
      if (footer) {
        const navs = footer.querySelectorAll(".nav");
        tl.to(
          navs[0],
          {
            duration: 0.3,
            x: "-4rem",
            autoAlpha: 0,
            ease: "circ.in",
          },
          "start"
        ).to(
          navs[1],
          {
            duration: 0.3,
            x: "4rem",
            autoAlpha: 0,
            ease: "circ.in",
          },
          "start+=0.1"
        );
      }

      // HIDE CLOSURE
      const closure = data.current.container.querySelector(".main-closure");
      if (closure) {
        tl.to(closure, { duration: 0.3, autoAlpha: 0, y: "1.5rem" }, "start");
      }

      // Get col 1 2 3 and 4
      const items = iso.filteredItems;
      const w = iso.size.width;
      let wCol = w / 4;
      if (window.innerWidth < 768) {
        wCol = w;
      } else if (window.innerWidth < 1024) {
        wCol = w / 2;
      }
      if (items) {
        items.forEach((item) => {
          const dir =
            item.position.x >= wCol * 3 ||
            (item.position.x >= wCol && item.position.x < wCol * 2)
              ? 1
              : -1;
          tl.to(
            item.element,
            {
              y: `${dir * 4}rem`,
              ease: "circ.in",
              duration: 0.3,
              autoAlpha: 0,
            },
            "start"
          );
        });
      }

      return tl.play();
    }
    function leaveSingle(data) {
      const tl = gsap.timeline({
        paused: true,
        onComplete: () => {
          window.scrollTo(0, 0);
          _.unmount();
        },
      });

      /** HIDE CONTENT */
      const content = data.current.container.querySelector(".content");
      if (content) {
        tl.to(
          content,
          {
            duration: 0.4,
            autoAlpha: 0,
            y: "-3rem",
            ease: "power.in",
          },
          "start"
        );
      }

      /** HIDE TRIGGER */
      const trigger = data.current.container.querySelector(".trigger");
      if (trigger) {
        tl.to(
          trigger,
          {
            autoAlpha: 0,
            x: "2rem",
          },
          "start"
        );
      }

      /** HIDE DECOR */
      const decor1 = data.current.container.querySelector(".decor1");
      const decor2 = data.current.container.querySelector(".decor2");
      if (decor1 && decor2) {
        tl.to(
          decor2,
          {
            autoAlpha: 0,
            x: "2rem",
            y: "2rem",
            ease: "expo.in",
          },
          "start"
        ).to(
          decor1,
          {
            autoAlpha: 0,
            x: "-2rem",
            y: "-2rem",
            ease: "expo.in",
          },
          "start+=0.1"
        );
      }

      return tl.play();
    }
  }

  sound() {
    const elts = this.container.querySelectorAll('.hover-sound');

    if( elts ) {
      elts.forEach(el => {
        const video = el.querySelector('video');
        if( video ) {

          // el.addEventListener('mouseenter', () => {
          //   el.classList.add('hover');
          //   video.muted = false;
          // })

          // el.addEventListener('mouseleave', () => {
          //   el.classList.remove('hover');
          //   video.muted = true;
          // })
          el.addEventListener('click', (e) => {
            e.preventDefault();
            
            el.classList.toggle('hover');
            if( el.classList.contains('hover')) {
              video.muted = false;
            } else {
              video.muted = true;
            }
          })
        }

      })
    }
  }

  button() {
    const btns = this.container.querySelectorAll(".btn, .toggle-menu");

    if (btns) {
      btns.forEach((btn) => {
        const hover = document.createElement("div");
        hover.classList.add("hover");
        btn.prepend(hover);
        new Button(btn);
      });
    }
  }

  drag() {
    const elts = document.querySelectorAll(".drag");

    if (elts) {
      elts.forEach((el) => {
        const isotopeEl = el.querySelector(".isotope-horizontal");
        const iso = new Isotope(isotopeEl, {
          itemSelector: "figure",
          layoutMode: "masonryHorizontal",
          horizontal: true, // ← cette option n’est pas standard, il faut Masonry modifié
        });

        const maxScroll = isotopeEl.scrollWidth - el.offsetWidth;

        Draggable.create(isotopeEl, {
          type: "x",
          bounds: { minX: -maxScroll, maxX: 0 },
          inertia: true,
          edgeResistance: 0.9,
          cursor: "grab",
          activeCursor: "grabbing",
        });

        window.addEventListener("resize", () => {
          const maxScroll = isotopeEl.scrollWidth - el.offsetWidth;
          Draggable.get(content).applyBounds({ minX: -maxScroll, maxX: 0 });
        });
      });
    }
  }

  marquee() {
    const elts = document.querySelectorAll(".marquee:not(.ready)");

    if (elts) {
      elts.forEach((el) => {
        el.classList.add("ready");
        const line = el.querySelector(".line");

        const scrollDirection = Number(el.dataset.dir ? el.dataset.dir : 1); // 1 = gauche, -1 = droite
        const speed = 40; // Pixels par seconde

        // Duplique les images pour un effet continu
        const images = line.innerHTML;
        line.innerHTML += images;
        this.lazyload.update();

        // Calcule la largeur totale de la marquee
        const marqueeWidth = line.scrollWidth / 2;

        // Initialise la position
        let position = 0;

        let cursor = 0;

        // Animation continue
        const animate = (timestamp) => {
          position += (speed / 100) * -scrollDirection; // Ajuste selon la vitesse et direction

          // Réinitialise la position si elle dépasse la largeur totale
          if (position <= -marqueeWidth) {
            position = 0;
          } else if (position >= 0) {
            position = -marqueeWidth;
          }

          line.style.transform = `translateX(${position}px)`;
          cursor = requestAnimationFrame(animate);
        };

        // Écouteur pour changer la direction en fonction du scroll
        let lastScrollY = window.scrollY;
        window.addEventListener("scroll", () => {
          const currentScrollY = window.scrollY;
          // if (currentScrollY > lastScrollY) {
          //   scrollDirection = Number(el.dataset.dir ? el.dataset.dir : 1); // Scroll vers le bas : gauche
          // } else if (currentScrollY < lastScrollY) {
          //   scrollDirection = -Number(el.dataset.dir ? el.dataset.dir : 1); // Scroll vers le haut : droite
          // }
          lastScrollY = currentScrollY;
        });

        if (el.dataset.hover) {
          el.addEventListener("mouseenter", () => {
            cancelAnimationFrame(cursor);
          });
          el.addEventListener("mouseleave", () => {
            cursor = requestAnimationFrame(animate);
          });
        }

        // Lance l'animation
        cursor = requestAnimationFrame(animate);
      });
    }
  }

  async sliderScreen() {
    const elts = document.querySelectorAll(".app-slider-screen");

    if (elts) {
      elts.forEach((slider) => {
        let timerSlider = 0;
        let current = -1;

        gsap.set(document.querySelector("html"), {
          background: "#201A27",
          height: '100%'
        });

        window.addEventListener("resize", () => {
          if (window.innerWidth < 1296) {
            gsap.set(slider, {
              // width: "1920px",
              width: "1296px",
              // height: "1080px",
              height: "864px",
              position: "fixed",
              top: "50%",
              left: "50%",
              y: "-50%",
              x: "-50%",
              scale: window.innerWidth / 1296,
            });
          }
        });
        window.dispatchEvent(new Event("resize"));

        /** DEBUG */
        const debugSelect = document.querySelector(".select-slides");
        if (debugSelect) {
          debugSelect.addEventListener("change", () => {
            goto(Number.parseInt(debugSelect.value), false);
          });
        }
        window.addEventListener("keyup", (e) => {
          if (e.key == "d") {
            if (HTML.classList.contains("show-debug")) {
              HTML.classList.remove("show-debug");
              goto(current, false);
              clearAllTimeout()
            } else {
              clearAllTimeout()
              // Show select
              HTML.classList.add("show-debug");
            }
          }
        });

        /** MESSAGES */
        let isPushShow = false;
        const data = { action: "screen_msg" };
        const { ajaxurl } = slider.dataset;
        // const transitionPush = lottie.loadAnimation({
        //   container: document.querySelector('.animation-push'),
        //   renderer: "svg",
        //   loop: false,
        //   autoplay: false,
        //   path: templateURI + '/static/bodymovin/push.json',
        // });

        async function showMsg() {
          const response = await fetch(ajaxurl, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Cache-Control": "no-cache",
            },
            body: new URLSearchParams(data),
          });
          const output = await response.json();

          if (output.success && output.data) {
            const { data } = output;

            // Check msg push
            const msgPush = slider.querySelector(".msg-push");
            if (msgPush) {
              if (
                data.msg_push.display &&
                data.msg_push.msg &&
                data.msg_push.msg != ""
              ) {
                if (data.msg_push.title != "")
                  msgPush.querySelector(
                    ".title"
                  ).innerHTML = `<h4>${data.msg_push.title}</h4>`;
                else msgPush.querySelector(".title").innerHTML = "";

                msgPush.querySelector(
                  ".desc"
                ).innerHTML = `${data.msg_push.msg}`;
                await sleep(200);
                msgPush.classList.add("show");
                // if( !isPushShow ) {
                await sleep(100);
                // transitionPush.stop();
                // transitionPush.play();
                // }

                isPushShow = true;
              } else {
                msgPush.classList.remove("show");
                isPushShow = false;
              }
            }

            // Check msg alert
            const msgAlert = slider.querySelector(".msg-alert");
            if (msgAlert) {
              if (
                data.msg_alert.display &&
                data.msg_alert.msg &&
                data.msg_alert.msg != ""
              ) {
                msgAlert.querySelector(".desc").innerHTML = data.msg_alert.msg;

                if(data.msg_alert.colors && data.msg_alert.colors.bg) {
                  msgAlert.style.background = data.msg_alert.colors.bg
                } 
                if(data.msg_alert.colors && data.msg_alert.colors.color) {
                  msgAlert.style.color = data.msg_alert.colors.color
                } 

                await sleep(200);
                msgAlert.classList.add("show");
                clearTimeout(timerSlider);
              } else {
                if (msgAlert.classList.contains("show")) {
                  goto(current < 0 ? 0 : current);
                }
                msgAlert.classList.remove("show");
              }
            }
          }

          await sleep(5000);
          showMsg();
        }
        showMsg();

        /** SLIDER */
        const slides = slider.querySelectorAll(".item");
        const transitions = [];
        const colors = ["violet", "vert", "bleu"];
        for (const color of colors) {
          const transitionAnim = lottie.loadAnimation({
            container: document.querySelector(".transition-slider-screen"),
            renderer: "svg",
            loop: false,
            autoplay: false,
            path: `${templateURI}/static/bodymovin/transition-${color}.json`,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid slice',
            }
          });

          transitions.push(transitionAnim);
        }

        function goto(index, timer = true) {
          const { duration } = slides[index].dataset;

          if (index == current) {
            timerSlider = setTimeout(() => {
              const next = index >= slides.length - 1 ? 0 : index + 1;
              goto(next);
            }, duration * 1000);
            return;
          }

          let delay = 0;

          if (current >= 0) {
            transitions[current % transitions.length].stop();
            transitions[current % transitions.length].play();

            const currentSlide = slides[current];

            gsap.to(currentSlide, {
              autoAlpha: 0,
              y: "-30%",
              ease: "expo.in",
              onComplete: () => {
                const video = currentSlide.querySelector("video");
                if (video) {
                  video.pause();
                }

                currentSlide.classList.remove("active");
              },
            });
            delay = 1.3;
          }

          const video = slides[index].querySelector("video");
          if (video) {
            video.play();
          }
          slides[index].classList.add("active");
          gsap.fromTo(
            slides[index],
            {
              y: "30%",
            },
            {
              autoAlpha: 1,
              y: "0%",
              ease: "expo.out",
              duration: 0.5,
              delay,
              onComplete: () => {
                const next = index >= slides.length - 1 ? 0 : index + 1;
                current = index;
                if (timer) {
                  timerSlider = setTimeout(() => {
                    goto(next);
                  }, duration * 1000);
                }
              },
            }
          );
        }

        goto(0);
      });
    }
  }

  slider() {
    const sliders = document.querySelectorAll(".slider");
    if (sliders) {
      sliders.forEach((slider) => {
        new Flickity(slider, {
          cellAlign: "left",
          contain: true,
          prevNextButtons: false,
          pageDots: false,
          watchCSS: true,
        });
      });
    }
  }

  grid(parent = document) {
    const _ = this;
    const grids = this.container.querySelectorAll(".list-articles");

    if (grids) {
      grids.forEach((grid) => {
        const iso = new Isotope(grid, {
          itemSelector: ".item",
          masonry: {
            columnWidth: ".base",
          },
        });

        /** Adapte delay */
        function adaptDelay() {
          // Get col 1 2 3 and 4
          const items = iso.filteredItems;
          const w = iso.size.width;
          const wCol = w / 4;
          if (items) {
            items.forEach((item) => {
              if (item.position.x >= wCol * 3) {
                item.element.classList.add("d-300");
              } else if (
                item.position.x >= wCol * 2 &&
                item.position.x < wCol * 3
              ) {
                item.element.classList.add("d-200");
              } else if (
                item.position.x >= Number(wCol) &&
                item.position.x < wCol * 2
              ) {
                item.element.classList.add("d-100");
              }
            });
          }
        }

        adaptDelay();

        /** Scroll progress */
        const progress = this.container.querySelector(".progress");
        if (progress) {
          const cursor = progress.querySelector(".cursor");
          const nbPart = 5;
          const bound = grid.getBoundingClientRect();

          if (this.container.offsetHeight > window.innerHeight * 1.5) {
            let nbLines = Math.round(
              (this.container.offsetHeight / (window.innerHeight * 0.5)) *
                nbPart
            );

            nbLines = nbLines > 30 ? 30 : nbLines;

            for (let i = 0; i < nbLines; i++) {
              const line = document.createElement("div");
              line.classList.add("line");
              line.innerHTML = "<div></div>";
              progress.querySelector(".inner").append(line);
            }
            const lines = progress.querySelectorAll(".line");

            if (lines) {
              lines.forEach((line, i) => {
                line.addEventListener("click", (e) => {
                  e.preventDefault();

                  gsap.to(HTML, {
                    ease: "expo.out",
                    duration: 0.7,
                    scrollTop:
                      i *
                      ((_.container.offsetHeight - window.innerHeight) /
                        lines.length),
                  });
                });

                let isActive = false;
                const tl = gsap.timeline({
                  paused: true,
                  onComplete: () => {
                    if (isActive) {
                      tl.reverse();
                      isActive = false;
                    }
                  },
                });

                tl.to(line, {
                  scaleX: 1.2,
                  scaleY: 1.8,
                  duration: 0.3,
                });

                line.addEventListener("mouseenter", () => {
                  tl.play();
                });

                line.addEventListener("mouseleave", () => {
                  if (tl.isActive()) {
                    isActive = true;
                  } else {
                    tl.reverse();
                  }
                });
              });
            }

            function scrollUpdate() {
              const { scrollY } = window;
              let percent =
                scrollY / (_.container.offsetHeight - window.innerHeight);

              if (percent < 0) percent = 0;
              else if (percent > 1) percent = 1;

              let current = Math.round(lines.length * percent);
              if (current < 0) current = 0;
              else if (current > lines.length - 1) current = lines.length - 1;

              for (const [i, line] of lines.entries()) {
                if (i <= current) {
                  line.classList.add("active");

                  if (i == current) {
                    gsap.to(line, {
                      scaleX: 1.2,
                      scaleY: 1.8,
                    });
                  } else {
                    gsap.to(line, {
                      scale: 1,
                    });
                  }
                } else {
                  line.classList.remove("active");
                  gsap.to(line, {
                    scale: 1,
                  });
                }
              }

              gsap.to(cursor, {
                left: `${(current / (lines.length - 1)) * 100}%`,
                // left: `${percent * 100}%`,
                duration: 0.1,
              });
            }

            window.removeEventListener("scroll", scrollUpdate);
            window.addEventListener("scroll", scrollUpdate);

            window.dispatchEvent(new Event("scroll"));
          } else {
            progress.remove();
          }
        }

        const filters = this.container.querySelectorAll("[data-filter]");
        const toggles = this.container.querySelectorAll(
          ".toggle-filter:not(.ready)"
        );
        if (toggles) {
          toggles.forEach((toggle) => {
            toggle.classList.add("ready");
            toggle.addEventListener("click", (e) => {
              e.preventDefault();

              HTML.classList.toggle("open-filter");
            });
          });
        }

        if (filters) {
          filters.forEach((filter) => {
            filter.addEventListener("click", (e) => {
              e.preventDefault();

              if (filter.classList.contains("active")) {
                return false;
              }

              const target = filter.dataset.filter;

              if (toggles) {
                toggles.forEach((toggle) => {
                  if (target != "item") {
                    toggle.classList.add("active-badge");
                  } else {
                    toggle.classList.remove("active-badge");
                  }
                });
              }

              HTML.classList.remove("open-filter");

              filters.forEach((f) => {
                f.classList.remove("active");
              });

              filter.classList.add("active");

              iso.arrange({
                filter: `.${target}`,
              });
            });
          });
        }
      });
    }
  }

  gridHours() {
    const elts = document.querySelectorAll('.grid-hours');

    if( elts ) {
      elts.forEach(grid => {
        const start = new Date();
        start.setHours(grid.dataset.start);
        start.setMinutes(0);
        start.setSeconds(0);
        const end = new Date();
        if( grid.dataset.start > grid.dataset.end ) end.setDate(end.getDate() + 1)
        end.setHours(grid.dataset.end);
        end.setMinutes(0);
        end.setSeconds(0);
        let now = new Date();
        const child = grid.querySelector('.grid-full')
        const timer = grid.querySelector('.timer');

        gsap.set(child, {
            marginTop : `${grid.offsetHeight / 2}px`,
            y : `${(now-start) / (end-start) * -100}%`
        })
          
        /** Timer */
        setInterval(() => {
          now = new Date();
          const h = (now.getHours() <= 9 ? '0' : '') + now.getHours();
          const m = (now.getMinutes() <= 9 ? '0' : '') + now.getMinutes();
          const s = (now.getSeconds() <= 9 ? '0' : '') + now.getSeconds();
          timer.innerHTML = `${h}:${m}:${s}`;

          gsap.set(child, {
            marginTop : `${grid.offsetHeight / 2}px`,
            y : `${(now-start) / (end-start) * -100}%`
        })
        })
      })
    }
  }

  bodymovin() {
    const tags = this.container.querySelectorAll(
      "[data-bodymovin]:not(.ready)"
    );

    if (tags) {
      tags.forEach((tag) => {
        tag.classList.add("ready");
        // tag.addEventListener("inview", () => {
        if (!tag.classList.contains("loaded")) {
          const anim = tag.dataset.bodymovin;
          // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
          fetch(anim).then((response) => {
            if (response.status == 200) {
              const l = lottie.loadAnimation({
                container: tag,
                renderer: "svg",
                loop: true,
                autoplay: !(
                  tag.dataset.bodymovinAutoplay &&
                  tag.dataset.bodymovinAutoplay != "0"
                ),
                path: anim,
              });
              l.addEventListener("DOMLoaded", () => {
                tag.classList.add("loaded");
              });
              tag.lottie = l;

              if (
                tag.dataset.bodymovinAutoplay &&
                tag.dataset.bodymovinAutoplay != ""
              ) {
                setTimeout(() => {
                  l.play();
                  tag.classList.add("loaded");
                }, Number.parseFloat(tag.dataset.bodymovinAutoplay) * 1000);
              } else {
              }
            }
          });
        } else if (tag.lottie) {
          tag.lottie.play();
        }
        // });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            // tag.lottie.pause();
          }
        });
      });
    }
  }

  poll() {
    const polls = document.querySelectorAll(".wp-polls:not(.is-ready)");

    if (polls) {
      polls.forEach((poll) => {
        poll.classList.add("is-ready");

        const btn = poll.querySelector("[data-pollid]");
        if (btn) {
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            if (typeof poll_vote === "function") {
              poll_vote(btn.dataset.pollid);

              setTimeout(() => {
                const iso = Isotope.data(".list-articles");
                iso.arrange();
              }, 2000);
            }
          });
        }
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
